module.exports = __webpack_public_path__ + "img/pocketgames.c5194344.png";